import {
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	EnhancedDropDownRHFWithLabel,
	FieldLayout,
	LabelPosition,
	RHookFormDatePicker,
	RHookFormTextFieldWithLabel,
	SubmitButton,
	SubmitButtonVariant,
} from "@websential/cosmic-v20";
import React, { useEffect, useState } from "react";

import { Calendar } from "primereact/calendar";
import { CountryService } from "../../services/common/CountryService";
import { Grid } from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { useNavigateToLogout } from "../../common/Common";

// import "./iataReportDataTableStyle.css";
// import { RHookFormDatePicker } from "../RHookFormDatePicker";
// import { RHookFormDatePicker } from 'components/RHookFormDatePicker';

export interface ITD1AdminFormHeadero {
	formMethods: any;
	countryList: any;
	onDateSelectionChangeHandler: (params: any) => void;
	onProvinceSelectionChangeHandler: (params: any) => void;
	onCheckRecordClickedHandler: () => void;
	provinceDDLItems: (params: any) => void;
}
export const TD1AdminFormHeader: React.FC<ITD1AdminFormHeadero> = ({
	formMethods,
	countryList,
	onCheckRecordClickedHandler,
	onProvinceSelectionChangeHandler,
	onDateSelectionChangeHandler,
	provinceDDLItems
}) => {
	// useEffect(() => {
	// 	// formMethods.setValue('startDate', new Date("Sun Jan 01 2024 00:00:00 GMT+0500"))
	// 	// formMethods.setValue('endDate', new Date("Fri Mar 31 2024 00:00:00 GMT+0500"))
	// 	// Get the current date
	// 	const currentDate = new Date();
	// 	// Set startDate to the first day of the current month
	// 	const startDate = new Date(
	// 		currentDate.getFullYear(),
	// 		currentDate.getMonth(),
	// 		1
	// 	);
	// 	// Set endDate to the last day of the current month
	// 	const endDate = new Date(
	// 		currentDate.getFullYear(),
	// 		currentDate.getMonth() + 1,
	// 		0
	// 	);
	// 	formMethods.setValue("startDate", startDate);
	// 	formMethods.setValue("endDate", endDate);
	// }, []);

	const [provinceDDL, setprovinceDDL] = useState([]);
	const navigateToLogout = useNavigateToLogout();
	useEffect(() => {
		if (countryList && Array.isArray(countryList)) {
			const canada = countryList.find(
				(item: any) => item.label === "Canada" || "canada"
			);
			if (canada) {
				(async () => {
					try {
						const response = await CountryService.getProvinceOrStateDDL(
							navigateToLogout,
							canada.value,
							"Province"
						);
						setprovinceDDL(response);
						//   provinceDDLItems(response);
					} catch (err) {
						console.error("error", err);
					}
				})();
			}
		}
	}, [countryList]);

	useEffect(() => {
		provinceDDLItems(provinceDDL);
	}, [provinceDDL]);

	return (
		<>
			<Grid
				container
				size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
				columnSpacing={2}
				sx={{
					margin: "0.5rem 0 0.5rem 0",
					borderRadius: "5px",
					backgroundColor: "#fff",
					width: "-webkit-fill-available",
					padding: "1rem 10rem 1rem 10rem",
					justifyContent: "space-between",
				}}
			>
				<Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
					<EnhancedDropDownRHFWithLabel
						selectName="province"
						label="Select Province"
						labelPosition={LabelPosition.Left}
						testId={`province`}
						items={provinceDDL ? [{ label: "Federal", value: "federal" }, ...provinceDDL] : []}
						labelColumns={3}
						// selectedItem={"all"}
						fieldColumns={9}
						onSelectionChangeHandler={onProvinceSelectionChangeHandler}
					/>
				</Grid>
				<Grid
					size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}
					sx={{ maxWidth: "40%!important" }}
				>
					<RHookFormDatePicker
						name="effectiveDate"
						testId="date"
						label="Select Date"
						labelPosition={LabelPosition.Left}
						onDateSelectionChangeHandler={onDateSelectionChangeHandler}
					/>
				</Grid>

				<Grid
					size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}
					sx={{
						// maxWidth:"30.4%!important",
						marginTop: "2px",
						"& .MuiButtonBase-root": { width: "45%" },
					}}
				>
					<FieldLayout
						testId={""}
						labelPosition={LabelPosition.Left}
						labelColumns={2.7}
						fieldColumns={9.3}
					>
						{/* <SubmitButton
							label="Check Record"
							testId="submit-button"
							// loading={isSubmitting}
							variant={SubmitButtonVariant.Primary}
							icon={<KeyboardArrowRightIcon />}
						/> */}
						<EnhancedButtonPrimeReact
							// icon="pi pi-plus"
							label="Check Record"
							raised
							onClickHandler={onCheckRecordClickedHandler}
							style={{ marginLeft: "1rem" }}
							severity={EnhancedButtonPrimeReactSeverity.Secondary}
						/>
					</FieldLayout>
				</Grid>
			</Grid>
		</>
	);
};
